import styles from "./CaseStudies.module.less";
import clsx from "clsx";
import DownloadCaseStudy from "./DownloadCaseStudy";
import { SectionTitle } from "../../../components/Section";

const resources = [
  {
    title: "Data Hub Chargebacks",
    content:
      "It seems like it should be straightforward to track the downstream value add and attribute that back to the data team’s central function. This whitepaper outlines the challenges with that.",
    link: "/Demyst - Data Hub Chargebacks.pdf",
  },
  {
    title: "Data Hub Maturity Model",
    content:
      "Discusses the stages of enterprises’ Data Hub maturity, from no hub to an ever growing and highly leveraged one.",
    link: "/DataHub Maturity Model.pdf",
  },
  {
    title: "External Data Ethics",
    content:
      "Discusses the ethics of using external data in AI and ML, advocating for an attribute-centric approach, with each attribute evaluated based on provenance, meaning, and biases.",
    link: "/External Data Ethics.pdf",
  },
  {
    title: "External Data Management - Applying the CDMC Framework",
    content:
      "Data leaders need to consider the risks, responsibilities and opportunities associated with harnessing external data and, across all aspects of the CDMC framework, how external data is necessarily a centrally managed function.",
    link: "/External Data Management - Applying The CDMC Framework.pdf",
  },
  {
    title: "Extracting Business Value from External Data in 2023",
    content:
      "Demyst’s product team conducted in-depth interviews with data experts across industries and regions on external data adoption. This white-paper summarizes the findings and shares best practices to optimize ROI for data initiatives.",
    link: "/Extracting Business Value from External Data in 2023.pdf",
  },
  {
    title: "The External Data Imperative",
    content:
      "How external data drives value: More rows (meaning more observations), more columns (meaning more features), and a better analytical algorithm, multiplicatively combine to drive value.",
    link: "/The External Data Imperative.pdf",
  },
];

const NewCaseStudies = ({ className }) => {
  return (
    <div className={clsx("section-layout", className)}>
      <div className={styles.container}>
        <SectionTitle>White Papers</SectionTitle>
        {resources.map(({ title, content, link }) => (
          <div key={title} id={title}>
            {/* <Image src={Featured} layout="fill" objectFit="cover" /> */}
            <div className={styles.filter} />
            <div className={styles.logo}>{/* <Image src={Anz} width={100} height={80} /> */}</div>
            <h2>{title}</h2>
            <p>{content}</p>
            <DownloadCaseStudy
              className={styles.cta}
              autoWidth
              size="md"
              variant="inverted"
              url={link}
              wp
              data-test-id="home-hero-button"
              title={title}
            >
              Download White Paper
            </DownloadCaseStudy>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewCaseStudies;
